import React from 'react';
import PropTypes from 'prop-types';
import ReactToolTip from 'react-tooltip';
import '../styles/hcHomepageStyles.css';

export const InfoWidget = (props) => {
    return (
        <span
            className="infoWidget"
            style={props.customStyle}
            data-tip={props.toolTipText}>
                ? {/* This is the question mark being displayed inside the InfoWidget circle */} 
            <ReactToolTip
                effect="solid"
                place="top"
                className="skillToolTip"
                type="light"
                wrapper="span" 
            />
        </span>
    );  
};

InfoWidget.defaultProps = {
    toolTipText: 'No information/No informacion',
    customStyle: {},
};

InfoWidget.propTypes = {
    customStyle: PropTypes.object,
    toolTipText: PropTypes.string,
};

export default InfoWidget;




// WEBPACK FOOTER //
// ./src/components/InfoWidget.jsx